<template>
  <section class="container client-testimonials">
    <h2>
      <contentful-text
        :item="contentfulText('pictureday-homepage-2023-v01-testimonials-title')"
        :render-inline="true"
      />
    </h2>
    <div class="row">
      <div class="col-xs-12 col-md-8 col-md-offset-2">
        <testimonial-carousel :testimonials="testimonials" />
      </div>
    </div>
  </section>
</template>

<script>
import TestimonialCarousel from '../ContentItems/ClientTestimonialCarousel.vue'

export default {
  name: 'ClientTestimonials',
  components: {
    TestimonialCarousel
  },
  computed: {
    content () {
      return this.$store.state.pageContent
    },
    testimonials () {
      return this.$store.getters.testimonialsSorted
    }
  }
}
</script>

<style lang="scss" scoped>
h2 {
  font-family: $font-barlow-condensed;
  font-size: 1.625rem;
  font-weight: 600;
  line-height: 1.875rem;
  text-transform: uppercase;
  margin-bottom: 2rem;
  text-align: center;

  @media screen and (min-width: $screen-sm-min) {
    font-size: 3.375rem;
    line-height: 3.375rem;
  }
}

.client-testimonials {
  border-bottom: 1px solid #e5e5e5;
  padding-bottom: 3rem;

  @media screen and (min-width: $screen-sm-min) {
    border-bottom: none;
    padding-bottom: 0;
  }
}
</style>



// WEBPACK FOOTER //
// WebResources/vue/pictureday/home/index/components/ContentSections/ClientTestimonials.vue